'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var eventemitter3 = {exports: {}};

exports.eventemitter3 = eventemitter3;
